__turbopack_context__.v({
  "activeBurger": "JOrVsq_activeBurger",
  "burgerHolder": "JOrVsq_burgerHolder",
  "burgerIcon": "JOrVsq_burgerIcon",
  "megaMenuCms": "JOrVsq_megaMenuCms",
});
